import { inject, injectable } from 'inversify';
import { DI_TYPES } from '../../di-types';
import { readonly } from '../../util/readonly-proxy';

export type FeatureName = 'INDEXEDDB_EVENTS' | 'IFRAME_NATIVES';

export type FeatureStates = { [key in FeatureName]?: boolean };

@injectable()
export class V2ClientFeatureState {
  private features: FeatureStates;

  constructor(@inject(DI_TYPES.DefaultFeatureStates) defaultFeatureStates: FeatureStates) {
    this.features = { ...defaultFeatureStates };
  }

  public setFeatureState(featureName: FeatureName, isEnabled: boolean) {
    this.features[featureName] = isEnabled;
  }

  public getFeatureState(featureName: FeatureName) {
    return this.features[featureName] ?? false;
  }

  public getFeatureStates() {
    return readonly(this.features);
  }
}
